export default "__VITE_ASSET__CR3Q8QDW__"